import clsx from 'clsx';

import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  isSelected?: boolean;
  statusModifierClassName?: string;
  statusText: string;
}

export default class InventorySquareIndicator extends PureBaseComponent<Props> {
  render() {
    const { isSelected, statusModifierClassName, statusText } = this.props;
    const className = clsx('InventorySquareIndicator', {
      'is-selected': isSelected,
    });
    const statusClassName = clsx('InventorySquareIndicator-indicator', statusModifierClassName);
    return (
      <div className={className}>
        <div className={statusClassName} />
        <div className="InventorySquareIndicator-statusText">{statusText}</div>
      </div>
    );
  }
}
